import { NgClass } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBars, type IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-main',
  imports: [
    RouterModule,
    RouterOutlet,
    SidebarComponent,
    FaIconComponent,
    NgClass
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
  readonly isSidebarOpen = signal(false);

  readonly menuIcon: IconDefinition = faBars;

  toggleSidebar(): void {
    this.isSidebarOpen.update(value => !value);
  }
}
